









import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconCross extends Vue {
    @Prop({ type: Number, default: 15 }) readonly size!: number
    @Prop({ type: Number, default: 2 }) readonly width!: number
    @Prop({ type: Boolean, default: false }) readonly closeButton!: boolean
    @Prop({ type: Boolean, default: false }) readonly centered!: boolean
}
